import FieldBase from './FieldBase'
import WidgetsInput from '@/components/widgets/input/WidgetsInput'

export default class extends FieldBase {
  constructor({ hiddenWidgets, ...args }) {
    super(args)
    const { form, fieldName, fieldValue } = this.formData
    const errors = this.getErrorsForPath(this.modelPath)
    this.component = WidgetsInput
    this.listeners = {
      update: value => this.$set(form, fieldName, value)
    }
    this.props = {
      widgets: fieldValue,
      errors: errors || [],
      hiddenWidgets
    }
  }
}
